var styles = {"box":"Pagination_box_kqlnh_1","box__inner":"Pagination_box__inner_kqlnh_10","info":"Pagination_info_kqlnh_17","progress":"Pagination_progress_kqlnh_31","btn":"Pagination_btn_kqlnh_49"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
